<div class="_home-desktop-page">

	<div class="_container _name-container">
		<p>{{tenant?.name ?? 'DIGIBANK' | translate}}</p>
	</div>

	<div class="_container _statistics-container">
		<impact-statistics-component [hideFilters]="true"></impact-statistics-component>	
	</div>

	<div class="_container _intro-container">
		<button *ifUserHasPermissions="[UserPermissions.WriteTenants]" type="button" class="_button _go-to-digibank-button" (click)="goToDigibankPage()">
			<ion-icon src="./assets/icons/edit-outline.svg"></ion-icon>
		</button>
		<div [innerHTML]="tenant?.intro"></div>	
	</div>

</div>
